"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logarithm = void 0;
function logarithm(base, y) {
    return Math.log(y) / Math.log(base);
}
exports.logarithm = logarithm;
//# sourceMappingURL=math.js.map